import styled from 'react-emotion';
import { space, color } from 'styled-system';
import { bouncyBoyMixin, clipTextMixin } from '../../../styles';

export const DashboardTabWrapper = styled('footer')`
  ${space}
  ${color}
  display: inline-flex;
  align-items: flex-start;
  height: 48px;
  overflow-x: scroll;
  overflow-y: hidden;
  background: ${props => props.theme.colors.greyscale[4]};
  border-top: 1px solid ${props => props.theme.colors.greyscale[3]};
`;

export const DashboardTab = styled('div')`
  ${space}
  ${color}
  border-radius: 0px 0px 6px 6px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  cursor: pointer;
  font-weight: ${props => props.active ? 1000 : 400};
  height: ${props => props.active ? '90%' : '55%'};
  opacity: ${props => props.isSortOrdering ? 0.5 : 1};
  will-change: height;
  transition: margin-left 0.2s ease-in-out, opacity 0.1s ease-in-out, height 0.1s ease-in-out, background 0.5s ease-in-out;
  font-family: 'proxima-nova', Sans-Serif;
  user-select: none;
  font-size: .8em;
  
  p {
    margin: 0;
    letter-spacing: 1px;
    ${clipTextMixin}
  }
`;

export const AddTabButton = styled('div')`
  ${color}
  font-size: 21px;
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
  padding-top: 6px;
  padding-right: 12px;
  ${space}
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.colors.clientPrimary};
  }
  ${bouncyBoyMixin}
`;
